import { render, staticRenderFns } from "./TableFeedBack.vue?vue&type=template&id=7b664bac&scoped=true"
import script from "./TableFeedBack.vue?vue&type=script&lang=js"
export * from "./TableFeedBack.vue?vue&type=script&lang=js"
import style0 from "./TableFeedBack.vue?vue&type=style&index=0&id=7b664bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b664bac",
  null
  
)

export default component.exports